<template>
<div>
    <section class="page-title" style="background-color:#c8d7ed;">
    <div class="center">
      <v-layout row wrap>
        <v-flex xs12 sm12 lg7>
        <p class="label-planos">Convênio Plano Odontológico</p>
        <h1 class="the-title"><span style="color:#194383;">Atualize</span> os dados</h1>
        <h1 class="the-title" style="font-size: 40px;"><span style="color:#194383;">Inclua</span> dependentes e agregados</h1>
        <p>Advocacia, </p>
        <p>Digite o CPF, confirme seus dados cadastrais e faça a inclusão dos Dependentes e Agregados, caso queira. </p>
        <br>
        <p>Estagiário(a), </p>
        <p>Faça a sua adesão e dos Dependentes e Agregados, caso queira.</p>
        <p>Tenha o melhor da odontologia!</p>
        <v-checkbox
            v-model="contrataccept"
              label=""
              color="#d10a10"             
          >  
          <span slot="label">Confirmo a atualização dos dados cadastrais junto à CAARJ, para envio ao Plano Odontológico PrimaVida Dental.</span>                  
          </v-checkbox>
        </v-flex>
        <v-flex xs12 sm12 lg5 >
          <v-img src="https://www.apvs.com.br/assets/uploads/parceiros/caarj.png" max-width="600px" ></v-img>
        </v-flex>
        <v-flex xs12 sm12 lg5 >
          <!-- <v-img src="https://www.apvs.com.br/assets/uploads/parceiros/caarj.png" max-width="500px" ></v-img> -->
          <div class="planos-wrapper" style="background-color:#c8d7ed;">
          <p class="planos-title" style="color:#194383;">Área de Acesso</p>
          <v-layout align-center>
        <v-flex xs12 sm12 lg12>
          <v-card
          flat
          max-height="600px"
          max-width="500px"
          class="mx-auto localizacao"
          style="border: 1px solid; border-color: #194383;border-radius: 10px;">
          <v-card-text>
              <v-flex xs12 sm12 lg10>
              <v-container grid-list-md>
              <v-layout align-center justify-center row wrap>
              <v-flex xs12 sm12 lg8>      
              <v-text-field
              :disabled="!contrataccept"
              v-model="cpf"
              label="Digite o CPF"
              v-validate="'required|cpf'"
              :error-messages="errors.collect('cpf')"
              mask="###.###.###-##"
              data-vv-name="cpf"        
              ></v-text-field>
              </v-flex>    
              <v-flex xs7 sm7 md7 lg3 >
              <v-btn
              :disabled="!contrataccept"
              style="border-radius: 6px;"               
              dark
              @click="consultaTitular()"
              color="#194383"
              :loading="loading"
              >Aderir</v-btn>
            </v-flex>
              <!-- </v-layout> -->
              </v-layout>
              </v-container>
              </v-flex>
          </v-card-text>
          </v-card>
        </v-flex>
        </v-layout>
        </div>
        </v-flex>
      
        </v-layout>
    </div>
</section>

<section class="page-content center">
    <p class="title-label" style="color:#194383;">Sobre a parceria</p>
    <p>A CAARJ fechou em 01/09/2019, um convênio com a PrimaVida Dental e está disponibilizando para toda advocacia em dia com a OAB, estagiários (as) e seus familiares um plano dental de qualidade sem carência e ampla rede credenciada.</p>


    <v-layout row wrap>
    <v-flex xs12 sm12 lg7>
    <p class="title-label" style="color:#194383;">Como utillizar</p>
    <p>Basta apresentar a carteira da ordem a um dos dentistas da rede credenciada da operadora. </p>
    </v-flex>
    <v-flex xs12 sm12 lg7>
    <p class="title-label" style="color:#194383;">Acesso à rede credenciada</p>
    <a href="http://www.primavida.com.br/redecredenciada" target="_blank">http://www.primavida.com.br/redecredenciada</a>
    </v-flex>
    <v-flex xs12 sm12 lg5>
    <img src="../Content/images/preco_titular.png" width="100px">&nbsp;
    <img src="../Content/images/valor_estagiario.png" width="100px">&nbsp;
    <img src="../Content/images/preco_dependente.png" width="100px">&nbsp;
    <img src="../Content/images/preco_agregado.png" width="100px">
    </v-flex>
    <v-flex xs12 sm12 lg7>
    <p class="title-label" style="color:#194383;">Quem pode aderir ao Plano?</p>
    <ul>Dependentes:</ul>
    <li>Filhos / Enteados</li>
    <li>Cônjuge / Companheiro</li>
    <br>
    <ul>Agregados:</ul>
    <li>Pai / Padrasto</li>
    <li>Mãe / Madrasta</li>
    <br>
    </v-flex>
    <v-flex xs12 sm12 lg6>
    <p class="title-label" style="color:#194383;">Principais Vantagens</p>
    <!-- <p>A Primavida tem planos atrativos, flexíveis e acessíveis para você e sua família, confira:</p> -->
    <li>Credenciamento de dentista por indicação</li>
    <li>Inclusão de dependentes e agregados</li>
    <li>Desconto em medicamentos nas farmácias &nbsp;<img src="../Content/images/raia.jpg" width="60px"> &nbsp; <img src="../Content/images/drogasil.jpg" width="110px"></li>
    <li>Autorização de tratamentos on-line</li>
    <li>Abrangência Grupo de Municípios RJ</li>
    <li>Sem limites para utilização</li>
    <li>Aplicativo para celular</li>
    <li>Sem carências</li>
    <br>
    </v-flex>
    <v-flex xs12 sm12 lg12>
    <p class="title-label" style="color:#194383;">Características do Plano</p>    
    </v-flex>
    <v-flex xs12 sm12 lg7>
    <ul>Advocacia:</ul>
    <li>Nome do Plano: SMILE MIX</li>
    <li>Nº de Registro do Produto na ANS: 483.735/19-5 </li>
    <li>Valor do Plano: R$ - ISENTO </li>
    <li>Tipo de contratação: Coletivo por Adesão</li>
    <li>Abrangência Geográfica: Grupo de Municípios RJ </li>
    <li>Vigência / Movimentação Cadastral (inclusão, exclusão); Movimentações feitas até o dia 30</li>
    <br>
    </v-flex>
    <v-flex xs12 sm12 lg5>
    <ul>Estagiários(as) / Dependentes / Agregados </ul>
    <li>Nome do Plano: CLÁSSICO RJ COLETIVO POR ADESÃO</li>
    <li>Nº de Registro do Produto na ANS: 475.855/16-2</li>
    <li>Valor do Plano: R$22,00 mensal por dependente / R$ 25,66 mensal por agregado</li>
    <li>Tipo de contratação: Coletivo por Adesão</li>
    <li>Abrangência Geográfica: Grupo de Municípios RJ</li>
    <li>Vigência / Movimentação Cadastral (inclusão, exclusão): Concomitante a confirmação de pagamento.</li>
    <br>
    </v-flex>
    <v-flex xs12 sm12 lg12>
    <p class="title-label" style="color:#194383;">App PrimaVida Beneficiário</p>    
    </v-flex>
    <v-flex xs5 sm5 lg2>
    <img src="../Content/images/app_android.png" width="120px"><br>
    <a href="https://play.google.com/store/apps/details?id=br.com.primavida.associado" target="_blank"><img src="../Content/images/android.png" width="120px"></a>&nbsp;
    </v-flex>
    <v-flex xs5 sm5 lg5>
    <img src="../Content/images/app_apple.png" width="120px"><br>
    <a href="https://apps.apple.com/br/app/primavida-dental-associado/id1464690839" target="_blank"><img src="../Content/images/apple_stote.png" width="120px" ></a>&nbsp;
    </v-flex>
    
    </v-layout>
    <br>
    <p class="title-label" style="color:#194383;">Principais Coberturas (Rol da ANS)</p>
    <div class="icone consultas">
        <span class="icon"></span>
        <p><strong>Consultas</strong> - Consultas iniciais para o plano de tratamento;</p>
    </div>
    <div class="icone urgencia">
        <span class="icon"></span>
        <p><strong>Urgência</strong> - Diversos procedimentos de urgência odontológica;</p>
    </div>
    <div class="icone cirurgia">
        <span class="icon"></span>
        <p><strong>Cirurgia</strong> - Cirurgias odontológicas de pequeno porte realizada em consultórios;</p>
    </div>
    <div class="icone dentistica">
        <span class="icon"></span>
        <p><strong>Dentística</strong> - Restaurações e obturações em material estético (Resina) e amálgama;</p>
    </div>
    <div class="icone endodontia">
        <span class="icon"></span>
        <p><strong>Endodontia</strong> - Tratamento de canais;</p>
    </div>
    <div class="icone periodontia">
        <span class="icon"></span>
        <p><strong>Periodontia</strong> - Tratamento de gengivas;</p>
    </div>
    <div class="icone odontopediatria">
        <span class="icon"></span>
        <p><strong>Odontopediatria</strong> - Atendimento especializado para crianças;</p>
    </div>
    <div class="icone radiologia">
        <span class="icon"></span>
        <p><strong>Raio X</strong> - Periapical, interproximal (bite-wing), oclusal, periapical completa (levantamento radiográfico);</p>
    </div>
    <div class="icone protese">
        <span class="icon"></span>
        <p><strong>Próteses</strong> - Coroa provisória, Restauração, Coroa, Núcleo e Bloco metálico para dentes permanentes posteriores, Coroa em Cerômero para dentes permanentes anteriores (Entende-se como dentes permanentes anteriores, os dentes definitivos da frente, que correspondem do canino a canino);</p>
    </div>
    <div class="icone profilaxia">
        <span class="icon"></span>
        <p><strong>Prevenção</strong> - Profilaxia / Aplicação de Flúor;</p>
    </div>
    <div class="icone exodontia">
        <span class="icon"></span>
        <p><strong>Exodontia</strong> - Extração, inclusive de siso incluso;</p>
    </div>
    <div>
        <p>Para acessar a cobertura do Rol da ANS, favor clicar <a href="http://www.primavida.com.br/emkt/rol_procedimentos.pdf" target="_blank">aqui.</a></p>
    </div>
    <v-flex xs12 sm12 lg12>
    <p class="title-label" style="color:#194383;">Uma parceria</p>    
    </v-flex>
    <v-layout row wrap>
    <v-flex xs12 sm12 lg12>
    <img src="../assets/logo.png" width="150px">
    </v-flex>
    <v-flex xs12 sm12 lg12 style="text-align: end;">
    <img src="../Content/images/logo-ans.png" width="170px">
    </v-flex>
    </v-layout>
    <div class="contrataragora"> 
     <v-fade-transition mode="out-in">    
    <div class="exibeplanos" >
    <v-flex xs12 sm12 lg12  v-if="exibeformulario && contrataccept">
    <div class="plano-selecionado" style="background: #f1f1f1;color:#194383;"><span style="color:#194383;">CAARJ * Titular: SMILE MIX * 483.735/19-5 * R$ {{valorContrato}} -  * COLETIVO POR ADESÃO</span></div>
    <v-stepper v-model="e1">
    <v-stepper-header>

      <v-stepper-step :complete="e1 > 1" step="1" :editable="editPassos" >Dados Pessoais</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2" step="2" :editable="editPassos">Beneficiários</v-stepper-step>

<v-divider></v-divider>

      <v-stepper-step :complete="e1 > 3" step="3" :editable="editPassos">Beneficiários</v-stepper-step>

    </v-stepper-header>
    <v-stepper-items>

<!-- PASSO 1 -->
      <v-stepper-content step="1">
    <v-container grid-list-md>
        <v-card
          class="mb-5"
          min-height="200px"
          flat
        >
        <v-layout row wrap>
            <v-flex xs12 sm12 lg12>      
            <v-text-field
            disabled
            v-model="financialManagers.firstName"
            label="Nome Completo"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg8>      
            <v-text-field
            v-model="carrj.email"
            label="E-mail"
            box
            v-validate="'required|email'"
            :error-messages="errors.collect('email')"
            data-vv-name="email"
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            v-model="carrj.telefone"
            label="Tefefone"
            return-masked-value mask="(##)#####-####"
            box
            v-validate="'required'"
            :error-messages="errors.collect('cellPhone')"
            data-vv-name="cellPhone"
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12>
            <v-checkbox
            v-model="acceptTermos"
              color="#d10a10"
          >
          <span slot="label">Li o <a @click.stop :href="'https://ecommerce.primavida.com.br/contratos/Termo_uso_dados.pdf'" target="popup" :onclick="`window.open('http://www.primavida.com.br',popup,width=800,height=600); return false;`">termo em anexo</a> e confirmo a minha aceitação, no qual estou de acordo com a Politica de Privacidade da PrimaVida Dental.</span>
          </v-checkbox>
          </v-flex> 
      <v-flex md12 xs12 sm12 lg3>
        <v-btn
            :disabled="!acceptTermos"
            style="border-radius: 8px;"
            large                
            dark
            color="#194383"
            @click="avancaPasso1()"
            >Continuar
        </v-btn>
      </v-flex> 
        </v-layout>
        </v-card>
        </v-container>
      </v-stepper-content>
    <!-- FIM DO PASSO 1 -->

    <!-- PASSO 2 --> 
      <v-stepper-content step="2">
        <v-container grid-list-md>
        <v-card
          class="mb-5"
          min-height="200px"
          flat
        >
        <v-layout row wrap>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            
            v-model="cep"
            label="CEP"
            return-masked-value mask="#####-###"
            v-validate="'required'"
            :error-messages="errors.collect('cep')"
            data-vv-name="cep"
            box
            
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg9>      
            <v-text-field
            
            v-model="carrj.rua"
            label="Rua"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg3>      
            <v-text-field
            v-model="carrj.numero"
            label="Número"
            type="number"
            v-validate="'required'"
            :error-messages="errors.collect('numero')"
            data-vv-name="numero"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            
            v-model="carrj.bairro"
            label="Bairro"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            
            v-model="carrj.cidade"
            label="Cidade"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg4>      
            <v-text-field
            
            v-model="carrj.estado"
            label="Estado"
            box
            ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg12>
            <v-text-field
            v-model="carrj.complemento"
            label="Complemento"
            box
            ></v-text-field>
            </v-flex>
            <br>
            <v-flex xs12 sm2 lg3>
        <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#194383"
            @click="avancaPasso3()"
            >Continuar
        </v-btn>   
        </v-flex>  
         <v-flex xs12 sm12 lg9> 
            <p style="font-size: 16px;line-height: 20px;color: rgb(102, 103, 103);">Caso queira alterar o seu endereço, favor entrar em contato atraves do <span style="color:#194383"> whatsapp (21) 97164.0379</span></p>
        </v-flex> 
        </v-layout>
        </v-card>                
        </v-container>
      </v-stepper-content>

      <!-- FIM DO PASSO 2 -->

      <!-- PASSO 3 -->
  <v-stepper-content step="3">  
    <v-container fluid grid-list-md>
    <v-data-iterator
      v-if="dependentes != ''"
      :items="dependentes"
      :rows-per-page-items="rowsPerPageItems"
      rows-per-page-text="Linhas por página" 
      :pagination.sync="pagination"
      content-tag="v-layout"
      row
      wrap
      hide-actions
    >
      <template v-slot:header>
        <v-toolbar
          style="border-radius: 10px;"
          class="mb-2"
          color="#009B99"
          dark
          flat
        >
    <v-toolbar-title>Dependentes / Agredados</v-toolbar-title>
      </v-toolbar>
      </template>
      <template v-slot:item="props">
        <v-flex
          xs12
          sm6
          md4
          lg4
        >
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center;" class="subheading font-weight-bold">{{ props.item.firstName.toUpperCase() }}</v-card-title>

            <v-divider></v-divider>

            <v-list dense>
              
              <v-list-tile>
                <v-list-tile-content class="centralizar" >{{ props.item.parentage == '' ? 'TITULAR' : props.item.parentage}}</v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content class="centralizar" >R$ {{ (parseFloat(props.item.valuePlan).toFixed(2)).replace('.',',') }}</v-list-tile-content>
              </v-list-tile>              

              <v-list-tile>                
                <v-btn
                style="border-radius: 8px;"                                
                dark
                color="blue-grey darken-1"
                @click="editItem(props.item)"
                >Editar
                </v-btn>
                <v-btn
                v-if="!props.item.isHolder"
                style="border-radius: 8px;"                                
                dark
                color="error"
                @click="openDialogDelete(props.item)"
                >Excluir
                </v-btn>                
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </template>      
    </v-data-iterator>
  </v-container>
    <!-- DIALOG DA LISTA DE BENEFICIARIOS -->
    <v-flex xs12 sm12 lg12>
      <v-container grid-list-md v-if="!alertTitular">
        <v-layout row wrap justify-center>
          <v-btn
            @click="openDialogDependete()"                 
            dark              
            style="border-radius: 8px;"
            large                
            color="#cc9966"
            >
            Incluir Dependente / Agregado
            </v-btn>
        </v-layout>
      </v-container>         
  </v-flex>
    <v-dialog v-model="dialog" max-width="950px" persistent>                      
      <v-card>                                                        
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>                               
        </v-card-title>
        <!-- <v-card-title v-if="dependents.parentage">
          <span class="subtotal" style="background: #f1f1f1; color:#194383;">{{ infoPlano }}</span>                               
        </v-card-title> -->
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>               
              <v-flex xs12 sm12 lg4
              v-if="!dependents.isHolder">      
                <v-select                
                v-model="dependents.parentage"
                label="Parentesco"
                v-validate="'required'"
                :error-messages="errors.collect('parentage')"
                data-vv-name="parentage"
                :items="parentesco"
                item-text="text"
                item-value="value"
                box
                ></v-select>
                </v-flex>
              <v-flex xs12 sm12 lg8
              v-if="!dependents.isHolder">      
                <v-text-field
                v-model="dependents.firstName"
                label="Nome Completo"
                box
                v-validate="'required'"
                :error-messages="errors.collect('firstNameDep')"
                data-vv-name="firstNameDep"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 lg12
              v-else>      
                <v-text-field
                v-model="dependents.firstName"
                label="Nome Completo"
                box
                v-validate="'required'"
                :error-messages="errors.collect('firstNameDep')"
                data-vv-name="firstNameDep"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 lg4>      
                <v-text-field
                v-model="dependents.cpf"
                label="CPF"
                v-validate="'required|cpf'"
                :error-messages="errors.collect('cpfDep')"
                return-masked-value mask="###.###.###-##"
                data-vv-name="cpfDep"
                box
                ></v-text-field>
                </v-flex>              
                <v-flex xs12 sm12 lg4>      
                <v-text-field
                v-model="dataNascDependent"
                label="Data de Nascimento"
                v-validate="'required|date_format:dd/MM/yyyy'"
                :error-messages="errors.collect('dateOfBirthDep')"
                return-masked-value mask="##/##/####"
                data-vv-name="dateOfBirthDep"
                box
                ></v-text-field>
                </v-flex>                            
                <v-flex xs12 sm12 lg4>      
                <v-text-field
                v-model="dependents.susNumber"
                label="CNS (Cartão do SUS)"
                box
                ></v-text-field>
                </v-flex> 
                <v-flex xs12 sm12 lg3>      
                <v-select
                v-model="dependents.maritalStatus"
                label="Estado Civil"
                v-validate="'required'"
                :error-messages="errors.collect('maritalStatusDep')"
                data-vv-name="maritalStatusDep"
                :items="estadoscivil"
                item-text="text"
                item-value="value"
                box
                ></v-select>
            </v-flex>
              <v-flex xs12 sm12 lg3>      
                <v-select
                v-model="dependents.gender"
                label="Sexo"
                v-validate="'required'"
                :error-messages="errors.collect('genderDep')"
                data-vv-name="genderDep"
                :items="generos"
                item-text="text"
                item-value="value"
                box
                ></v-select>
                </v-flex>               
                <v-flex xs12 sm12 lg6>      
                <v-text-field
                v-model="dependents.motherName"
                label="Nome da Mãe"
                v-validate="'required'"
                :error-messages="errors.collect('motherNameDep')"
                data-vv-name="motherNameDep"
                box
                ></v-text-field>
                </v-flex>                                                    
            </v-layout>
            </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>        
          <v-btn dark color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" @click.native="salvarDependente">Salvar</v-btn>
          <v-btn dark color="red darken-1" style="border-radius: 8px; width: 130px;" @click.native="close">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIM DIALOG DEPENDENTES --> 

     <!-- DIALOG DELETA DEPENDENTE -->
    <v-dialog v-model="dialogDelete" max-width="600px" persistent> 
      <v-card>
        <v-card-title>
          <span class="headline">Confirmação de Exclusão</span>
        </v-card-title>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-card-text>Dependente: {{dependents.firstName}}</v-card-text>
              <v-card-text>Parentesco: {{dependents.parentage}}</v-card-text>
            </v-layout>
          </v-container>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark color="red darken-1" style="border-radius: 8px; width: 130px;" @click.native="deleteDependente(dependents.cpf)">Excluir</v-btn>
          <v-btn dark color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" @click.native="close">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIM DIALOG DELETA DEPENDENTE -->     
    
        <br>
        <v-flex xs12 sm12 lg12 v-if="alertTitular">
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-btn
                style="border-radius: 8px;"
                large                
                dark
                color="#cc9966"
                @click="openDialog()"
                >Incluir Titular
            </v-btn>
            </v-layout>
          </v-container>
          <br>
          <br>
        </v-flex>
    <div class="separator dark"></div>
    <v-container grid-list-md>
        <v-layout row wrap justify-center>
          <v-flex xs12 sm12 lg12>
            <div class="total-table">
                <p class="form-titulo" style="color:#194383;">Valores</p>
                <div class="row-table-wrapper">                  
                    <div class="col" style="width: 36%;">
                        <div class="row-table titular" v-if="estagiario">
                            <p>Beneficiário Titular</p>
                            <span class="total">R$ 22,00</span>
                        </div>
                        <div class="row-table dependentes-row">
                            <p>Dependente(s) / Agregado(s)</p>
                            <span class="total" style="color:#194383;">R$ {{valorDependentes.replace('.',',')}}</span>
                        </div>
                    </div>
                 
                    <div class="col" style="margin-right: 14%;">
                        <div class="row-table total-row">
                            <p>Total a pagar</p>
                            <span class="total" style="color:#194383;">R$ {{valorTotalProposta.replace('.',',')}}</span>
                        </div>
                    </div>
                </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>    
     <!-- FIM DO DIALOG DA LISTA DE BENEFICIARIOS -->
    <v-card-actions>      
      <v-flex md12 xs12 sm12 lg3>
        <v-btn
            style="border-radius: 8px;"
            large                
            dark
            color="#194383"
            @click="finalizarProposta()"
            :loading="loadingFinal"
            >Finalizar e enviar
        </v-btn>
      </v-flex>         
    </v-card-actions>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
<!-- FIM DO PASSO 3 -->
      

  <v-dialog v-model="dialogLoading" max-width="800px" max-height="500px" persistent> 
      <v-card>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
              <span class="total" style="font-size:1.7rem;">Cadastro concluído com sucesso!</span>              
              </v-card-title>
              <v-container
                    fluid
                    justify-center
                    class="resumo"
                  >
              <p class="resumo" v-for="mensagem in mensagemS4E" :key="`${mensagem}`">- {{mensagem}}</p>
              <br>                  
              <p class="resumo"><strong>Importante:</strong> Quando houver casos de inclusão de dependentes / agregados será praticado a rotina que se segue:.</p>
              <br>
              <p class="resumo">As inclusões realizadas até o dia 30 de cada mês serão incluídas para o vencimento 10, imediatamente posterior.</p>
              <br>
              <p class="resumo">Você receberá da CAARJ, através de uma empresa de cobrança autorizada, o boleto no primeiro dia útil de cada mês, com vencimento para o dia 10, referente ao plano odontológico COLETIVO POR ADESÃO contratado pela CAARJ, correspondente a todo grupo de dependente / agregado, quando houver,  podendo a vigência ser antecipada concomitante a confirmação / baixa de pagamento do mesmo.</p>
              <br>
              <p class="resumo"><strong>Somente após a confirmação / baixa de pagamento do boleto, a CAARJ enviará os dados dos dependentes / agregados para a PrimaVida dar início de vigência / início de uso ao plano odontológico.</strong></p>
              <br>
              <p class="resumo">Não havendo confirmação / baixa de pagamento do boleto , será subentendido pela CAARJ da desistência de inclusão.</p>
              <br>
              <p class="resumo"><strong>O vencimento dos boletos será todo dia 10 de cada mês.</strong></p>
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >
              <v-btn color="blue-grey darken-1" v-if="!loadingFinal" style="border-radius: 8px; width: 130px;" dark @click="confirmaContrato()">Fechar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
      </v-card>
    </v-dialog>

   </v-flex>       
   <!-- DIALOG ALTERA SENHA -->
  <v-dialog v-model="dialogSenha" max-width="450px" max-height="300px" persistent> 
      <v-card>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
              <span class="subtotal">Atualização de Senha (primeiro acesso)</span>              
              </v-card-title>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                    class="resumo"
                  >
              <v-flex xs12 sm12 lg6>      
                <v-text-field
                v-model="financialManagers.password"
                label="Nova Senha"
                v-validate="'required'"
                :error-messages="errors.collect('senha')"
                type="password"
                ref="password"
                data-vv-name="senha"
                box
                ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 lg6>      
                <v-text-field
                v-model="financialManagers.confirmPassword"
                label="Repetir Senha"
                type="password"
                :error-messages="errors.collect('password')"
                v-validate="'required|confirmed:password'"
                data-vv-name="password"
                box
                ></v-text-field>
              </v-flex>
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >
              <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click="atualizaSenha()">Salvar</v-btn>
              <v-btn dark color="red darken-1" style="border-radius: 8px; width: 130px;" @click.native="close">Cancelar</v-btn>              
              </v-container>
            </v-card-actions>
          </v-container>
      </v-card>
    </v-dialog>

    <!-- FIM DIALOG ALTERA SENHA -->


    </div>
    </v-fade-transition>
    </div>
</section>
<Snackbar ref=chamaSnackbar />
</div>
</template>
<script>
import Snackbar from '../components/snackbar.vue'
import axios from 'axios'
import { mapState } from 'vuex'
import { baseApiUrl } from '@/global'
import CpfValidate from '../components/validators/rules/cpf'
/* import CpfValidate from '../components/validators/rules/cpf' */
export default {
    components: {Snackbar},
     data(){
        return{
            contratoCancelado: false,
            estagiario: false,
            valorContrato: 'ISENTO',
            mensagemS4E: [],
            planoId: '',
            TitulaEmail: '',
            TitularFone: '',
            cpf: '',
            senha: '',
            idAssociado: '',
            possuiContrato: false,
            primeiroAcesso: false,
            atualizarSenha: false,
            exibeformulario: false,
            exibesenha: false,
            rowsPerPageItems: [12, 18],
            pagination: {
              rowsPerPage: 12
            },
            qtdDependentesInseridos: 0,
            pdfSelecionado: 8,
            verificaTitularS4e: '',
            pagCartao: false,
            loadingFinal: false,
            loading: false,
            financialManagUF: '',
            salesPrimavida: '5cc0a27ee2cead066040bfc9',
            brokerPrimavida: '5cc0a118e2cead066040bfc6',
            contrataccept: false,
            acceptTermos: false,            
            alertTitular: false,
            editPassos: false,
            editedIndex: '',
            editedIndexTitular: '',
            valorDependentes: '0,00',
            valorTotalProposta: '0,00',
            valorTitular: '0,00',
            search: '',
            dialog: false,
            dialogDelete: false,
            dialogLoading: false,
            dialogSenha: false,
            dependentes: [], 
            dependentesCaarj: [],
            titularContrato: [],
            e1: 0,
            bairro: '',
            cidade: '',
            estado: '',
            estados: [],
            parentesco: [  
            { value: 'CÔNJUGE', text: "CÔNJUGE" },
            { value: 'FILHO', text: "FILHO(A)" },            
            { value: 'ENTEADO', text: "ENTEADO(A)" },
            { value: 'PAI/MÃE', text: "PAI/PADRASTO" },
            { value: 'OUTRO', text: "MÃE/MADRASTA" },
            ],
            generos: [
            { value: 1, text: "Masculino" },
            { value: 0, text: "Feminino" } ],
            estadoscivil: [
            { value: "SOLTEIRO", text: "Solteiro(a)" },
            { value: "CASADO", text: "Casado(a)" },
            { value: "VIÚVO", text: "Viúvo(a)" },
            { value: "DIVORCIADO", text: "Divorciado(a)" } ],
            planoSelecionado: [],
            dataNasc: '',
            dataNascDependent: '',
            dependents: {
              id: '',
              parentage: '',
              valuePlan: '',
              lackOfCare: 1,
              rcaId: '',
              dateFirstPayment: '',
              isHolder: '',
              financialManagerId: '',
              firstName: '',
              lastName: '',
              dateOfBirth: '',
              gender: '',
              maritalStatus: '',
              cpf: '',
              motherName: '',
              susNumber: '',
              plansId: ''
            },
            defaultDependents: {
              id: '',
              parentage: '',
              valuePlan: '',
              lackOfCare: 1,
              rcaId: '',
              dateFirstPayment: '',
              isHolder: '',
              financialManagerId: '',
              firstName: '',
              lastName: '',
              dateOfBirth: '',
              gender: '',
              maritalStatus: '',
              cpf: '',
              motherName: '',
              susNumber: '',
              plansId: ''
            },
            financialManagers:{
                contratanteTitular: true,
                confirmPassword: '',
                password: '',
                rg: '',
                rgEmitter: '',
                homePhone: '',
                cellPhone: '',
                cellPhone2: '',
                email: '',
                cep: '',
                address: '',
                addressType: '',
                addressTypeName: '',
                addressNumber: '',
                addressComplement: '',
                district: '',
                city: '',
                state: '',
                proposalNumber: '',
                contractNumberS4: '',
                responsibility: '',
                cardNumber: '',
                cardValidity: '',
                cardFlag: '',
                cardDayExpiration: 15,
                dateSignatureContract: '',
                formOfPaymentId: '',
                firstName: '',
                lastName: '',
                dateOfBirth: '',
                gender: null,
                maritalStatus: null,
                cpf: '',
                motherName: '',
                susNumber: '',
                plansId: '',
                nsu: '',
                planoSelecionado: [],
                typeFm: 'FISICA',
                protocoloCancelamento: '',
                vendedor: '',
                matricula: '' 
            },
            
            caarjDependente: {
                tipo: '',
                nome: '',
                dataNascimento: '',
                cpf: '',
                sexo: '',
                plano: '',
                planoValor: '',
                nomeMae: '',
                telefoneFixo: '',
                celular:'',
                celular2:'',
                email:''
              },
            caarjDependenteDefalt: {
                tipo: '',
                nome: '',
                dataNascimento: '',
                cpf: '',
                sexo: '',
                plano: '',
                planoValor: '',
                nomeMae: '',
                telefoneFixo: '',
                celular:'',
                celular2:'',
                email:'',
                numeroProposta:''
              },  
              ativarAssociado: {
                codigoAssociado: "",
                codigoEmpresa: "",
                tipoSolicitante: "1",
                codigoSituacao: "1",
                comentario: "",
                motivoCancelamento: "13",
                dataFimAtendimento: "",
                protocolo: ""
              },
            
            caarjS4E:{
              codigoParceiro: 62768,
              codigoResponsavelFinanceiro: '',
              dependente: []
          },

          caarjS4EDefault:{
              codigoParceiro: 62768,
              codigoResponsavelFinanceiro: '',
              dependente: []
          },
            cep: '',
            carrj: {
              titular: '',
              cpf: '',
              sexo: '',
              rg: '',
              nascimento: '',
              cep: '',
              contrato: '',
              email: '',
              telefone: '',
              dependentes: [],
              numero: '',
              complemento: '',
              enviado: 'pendente',
              data: new Date().toISOString().substr(0, 10),
              rua: '',
              cidade: '',
              estado: '',
              bairro: '',
              contratoEmpresa: ''
            },
            dependentesCarregados: [],
            steppers: {
              default: 0,
              type: Number
            },
            formOfPayment: {
              uf: '',
              dayInclusion: '',
              type: ''
            },
            idUf: '',
            idUser: '',
            dictionary: {          
                custom: {
                uf: {
                    required: () => 'Informe a UF',
                },
                firstName: {
                    required: () => 'Informe o Nome',                   
                },
                firstNameDep: {
                    required: () => 'Informe o Nome',                   
                },
                email: {
                    required: () => 'Informe o Email',
                    email: () => 'Informe um Email válido'
                },
                cellPhone: {
                    required: () => 'Informe o Telefone',                   
                },
                password: {
                    required: () => 'Informe a Senha',
                    confirmed: () => 'A senha não confere'
                },
                senha: {
                    required: () => 'Informe a Senha'
                },
                dateOfBirth: {
                   required: () => 'Informe a Data de Nascimento' 
                },
                dateOfBirthDep: {
                   required: () => 'Informe a Data de Nascimento' ,
                   date_format:() => 'Data no formato errado'
                },
                gender: {
                   required: () => 'Informe o Sexo' 
                },
                genderDep: {
                   required: () => 'Informe o Sexo' 
                },
                maritalStatus: {
                   required: () => 'Informe o Estado Civil' 
                },
                maritalStatusDep: {
                   required: () => 'Informe o Estado Civil' 
                },
                motherName:{
                   required: () => 'Informe o nome da Mãe'
                },
                motherNameDep:{
                   required: () => 'Informe o nome da Mãe'
                },
                cep:{
                   required: () => 'Informe o CEP'
                },
                numero: {
                  required: () => 'Informe o Número, caso não tenha informe 0'
                },
                parentage: {
                  required: () => 'Informe o Parentesco'
                },
                cpfDep: {
                  required:() => 'Informe o CPF'
                }               
            }
            } 

        }
    },

    mounted : function(){
        this.$store.dispatch('EscondeToolbar')
        this.$store.dispatch('EscondeFooter')

        this.carregaDados()

        this.$validator.localize('pt', this.dictionary)
        //this.titularSemEndereco()
    },
    watch: {
    dialog(val) {
    val || this.close()
      },
    cep(){
      if(this.cep.length == 9)
      this.retornoViaCEP()
    }
    },
    computed: { 
      ...mapState({
        userloggedin: state => state.userloggedin
    }),      
        formTitle() {
          return this.editedIndex === '' ? 'Ficha de Adesão CAARJ OABRJ  - Coletivo Por Adesão Plano Odontologico PrimaVida Dental' : 'Ficha de Adesão CAARJ OABRJ  - Coletivo Por Adesão Plano Odontologico PrimaVida Dental'
        },
        formTitleTitular() {
          return this.editedIndexTitular === '' ? 'Incluir Titular' : 'Editar Titular'
        },
        infoPlano(){
          return this.dependents.parentage == 'AGREGADO'|'PAI/MÃE' ? 'CAARJ * Agregado: CLÁSSICO RJ COLETIVO POR ADESÃO * 475.855/16-2 * R$25,66' : 'CAARJ * Dependente: CLÁSSICO RJ COLETIVO POR ADESÃO * 475.855/16-2 * R$22,00'
        }
    },
    methods: {
        editItem(item) {
          this.editedIndex = item.id
          this.editedIndexTitular = item.id
          this.dependents = Object.assign({}, item)
          this.dataNascDependent = this.formatDateBrz(this.dependents.dateOfBirth)
          this.dialog = true

        },
        continuaProposta(){          
          if(sessionStorage.getItem('FinancialManager') != null){
          this.financialManagers = JSON.parse(sessionStorage.getItem('FinancialManager') || '[]')
          this.planoSelecionado = this.financialManagers.planoSelecionado
          this.idUser = this.financialManagers.id
          this.dataNasc = this.formatDateBrz(this.financialManagers.dateOfBirth)
          
          setTimeout(() => {
            this.e1 = 2
          }, 300);
        }
        },
         async deleteDependente(cpf) {             
            this.dependentes.forEach( (item, index) => {
            // se o id do array de objetos estiver em a1
            if (item.cpf == cpf)
                this.dependentes.splice(index,1) // entao remove                              
            })

            this.dependentesCaarj.forEach( (item2, index2) => {
            // se o id do array de objetos estiver em a1
            if (item2.cpf == cpf)
                this.dependentesCaarj.splice(index2,1) // entao remove 
                this.close()                                
            })

            if(this.dependentes == '')
            {
                this.valorDependentes = '0,00'
                this.valorTotalProposta = (parseFloat(this.valorTitular) + parseFloat(this.valorDependentes)).toFixed(2)
                this.close()
            }
            else
            {
            this.dependentes.forEach( (item2) => {
                this.valorDependentes = '0,00'
            // se o id do array de objetos estiver em a1
                this.valorDependentes = (parseFloat(this.valorDependentes) + parseFloat(item2.valuePlan)).toFixed(2)
                this.valorTotalProposta = (parseFloat(this.valorTitular) + parseFloat(this.valorDependentes)).toFixed(2)
                this.close()
            })            
            }
           
        },
        async carregaDados(){
            await axios.get(`${baseApiUrl}UFs`).then(res => {        
            if(res.data != null){      
            this.estados = res.data 
            this.financialManagers.plansId = this.planoSelecionado[6]  
            }              	
          })
        },
        
        avancaPasso1(){
            //this.TitulaEmail =  this.financialManagers.email                     
            if(this.carrj.email == '' || this.carrj.telefone == '')
            this.$validator.validateAll()
            else{
            //this.carrj.email = this.financialManagers.email
            //this.carrj.telefone = this.financialManagers.cellPhone
            this.e1 = 2
            } 
        }, 

        async avancaPasso3(){
          this.carrj.cep = this.cep
          if(this.carrj.cep == '' || this.carrj.rua == '' || this.carrj.bairro == '' || this.carrj.numero == '' || this.carrj.cidade == '' || this.carrj.estado == '')
          this.$validator.validateAll()
          else
            this.e1 = 3            
        },
      

        formatDate (date) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
      },
        formatDateBrz (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      formatDateCartao (date) {
        if (!date) return null

        const [year, month] = date.split('-')
        return `${month}/${year}`
      },

      async retornoViaCEP(){
          await axios
          .post(`${baseApiUrl}APIS4s/Endereco`, {"cep" : this.cep})
          .then(res => {        
            if(res.data != null){      
            this.financialManagers.address = res.data.Logradouro
            this.carrj.rua = res.data.Logradouro
            this.carrj.cidade = res.data.Municipio
            this.financialManagers.city = res.data.IdMunicipio
            this.carrj.estado = res.data.Uf
            this.financialManagers.state = res.data.IdUf
            this.carrj.bairro = res.data.Bairro
            this.financialManagers.district = res.data.IdBairro
            this.financialManagers.addressType = res.data.IdTipoLogradouro
            this.financialManagers.addressTypeName = res.data.TipoLogradouro
            }  
            else{
              var vmcep = this;
              vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
            }         	
            })       
      },

          
      async carregaDependentes(){
        var count = 0
        await axios.get(`${baseApiUrl}Dependents?filter[where][financialManagerId]=${this.idUser}`).then(res => {        
            if(res.data != null){      
            this.dependentes = res.data            
            this.qtdDependentesInseridos = this.dependentes.length
            if(this.planoSelecionado[4].includes('INDIVIDUAL') && this.qtdDependentesInseridos == 1)
            this.inserirDepBloq = true 
            if(this.dependentes.length == 1)
            this.valorDependentes = '0,00'
            for (let index = 0; index < this.dependentes.length; index++) {
              if(this.dependentes[index].isHolder) {
              this.valorTitular = parseFloat(this.planoSelecionado[0].replace(',', '.')).toFixed(2)              
              }else
              {
              count++
              this.valorDependentes = (parseFloat(this.planoSelecionado[0].replace(',', '.')).toFixed(2) * count).toFixed(2) 
              }
            }             
              this.valorTotalProposta = (parseFloat(this.valorDependentes) + parseFloat(this.valorTitular)).toFixed(2)/* + parseFloat(this.valorTaxaImplantacao) */ 
            }              	
			})  
      },
                 

      async salvarDependente(){
        if(this.dependents.cpf.replace(/\D/g, '') == this.cpf)
        {
          var vmcpf = this;
          vmcpf.$refs.chamaSnackbar.snack("#F9A825","O CPF do dependente não pode ser o mesmo do titular!","ATENÇÃO")
        }
        else{
        if(this.dataNascDependent == '' || this.dependents.fistName == '' || this.dependents.cpf == '' || this.dependents.parentage == '' || this.dependents.motherName == '' || this.dataNascDependent.length != 10 || !CpfValidate(this.dependents.cpf))
            this.$validator.validateAll()
        else
        {
        if(this.dependentesCarregados != '')
        {
        this.dependentesCarregados.forEach( (depcarr) => {
        // se o id do array de objetos estiver em a1
        if (depcarr.cpf == this.dependents.cpf){
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Dependente / Agregado já cadastrado!","ATENÇÃO")
        }
        else{
        this.dependentes.forEach( (item, index) => {
        // se o id do array de objetos estiver em a1
        if (item.id == this.dependents.id)
            this.dependentes.splice(index,1) // entao remove
        })
        if(this.dependents.parentage == 'FILHO' || this.dependents.parentage == 'CÔNJUGE' || this.dependents.parentage == 'ENTEADO'){
        this.dependents.valuePlan = '22'
        this.caarjDependente.planoValor = '22'
        }
        else
        {
            this.dependents.valuePlan = '25.66'
            this.caarjDependente.planoValor = '25.66'
        }
            this.caarjDependente.plano = 150
            this.caarjDependente.tipo = this.dependents.parentage
            this.caarjDependente.sexo = this.dependents.gender
            this.caarjDependente.cpf = this.dependents.cpf
            this.dependents.id = Math.floor(1000 + Math.random() * 1000)
            this.dependents.dateOfBirth = this.formatDate(this.dataNascDependent)
            this.caarjDependente.dataNascimento = this.formatDate(this.dataNascDependent)
            this.dependents.financialManagerId = this.idUser
            this.dependents.isHolder = false
            this.dependents.firstName = this.dependents.firstName.toUpperCase()
            this.caarjDependente.nome = this.dependents.firstName.toUpperCase()
            this.dependents.motherName = this.dependents.motherName.toUpperCase()
            this.caarjDependente.nomeMae = this.dependents.motherName.toUpperCase()
            this.valorDependentes = '0,00'                          
            this.dependentes.push(this.dependents)
            //this.caarjS4E.dependente.push(this.caarjDependente)
            this.dependentesCaarj.push(this.caarjDependente)
            this.dependentes.forEach( (item2) => {
                // se o id do array de objetos estiver em a1
            this.valorDependentes = (parseFloat(this.valorDependentes) + parseFloat(item2.valuePlan)).toFixed(2)
            this.valorTotalProposta = (parseFloat(this.valorTitular) + parseFloat(this.valorDependentes)).toFixed(2)
            })
        this.close()
        }
        })
        }
        else{

            this.dependentes.forEach( (item, index) => {
        // se o id do array de objetos estiver em a1
        if (item.id == this.dependents.id)
            this.dependentes.splice(index,1) // entao remove
        })
        if(this.dependents.parentage == 'FILHO' || this.dependents.parentage == 'CÔNJUGE' || this.dependents.parentage == 'ENTEADO'){
        this.dependents.valuePlan = '22'
        this.caarjDependente.planoValor = '22'
        }
        else
        {
            this.dependents.valuePlan = '25.66'
            this.caarjDependente.planoValor = '25.66'
        }
            this.caarjDependente.plano = 150
            this.caarjDependente.tipo = this.dependents.parentage
            this.caarjDependente.sexo = this.dependents.gender
            this.caarjDependente.cpf = this.dependents.cpf
            this.dependents.id = Math.floor(1000 + Math.random() * 1000)
            this.dependents.dateOfBirth = this.formatDate(this.dataNascDependent)
            this.caarjDependente.dataNascimento = this.formatDate(this.dataNascDependent)
            this.dependents.financialManagerId = this.idUser
            this.dependents.isHolder = false
            this.dependents.firstName = this.dependents.firstName.toUpperCase()
            this.caarjDependente.nome = this.dependents.firstName.toUpperCase()
            this.dependents.motherName = this.dependents.motherName.toUpperCase()
            this.caarjDependente.nomeMae = this.dependents.motherName.toUpperCase()
            this.caarjDependente.numeroProposta = Math.floor(10000 + Math.random() * 10000).toString()
            this.valorDependentes = '0,00'                          
            this.dependentes.push(this.dependents)
            //this.caarjS4E.dependente.push(this.caarjDependente)
            this.dependentesCaarj.push(this.caarjDependente)
            this.dependentes.forEach( (item2) => {
                // se o id do array de objetos estiver em a1
            this.valorDependentes = (parseFloat(this.valorDependentes) + parseFloat(item2.valuePlan)).toFixed(2)
            this.valorTotalProposta = (parseFloat(this.valorTitular) + parseFloat(this.valorDependentes)).toFixed(2)
            })
        this.close()
        }      

        }
      }
                    
      },
      openDialog(){
        this.tipoTitular = true
        this.$validator.reset()
          this.dependents = Object.assign({}, this.defaultDependents)
          this.editedIndexTitular = ''
          this.dataNascDependent = ''
          this.dependents.isHolder = true
        this.dialog = true
      },
      openDialogDependete(){
        if(this.dependentesCarregados != '')
        {
         var vm = this;
         vm.$refs.chamaSnackbar.snack("#F9A825","Contrato com dependentes / agregados já inseridos!","ATENÇÃO")
        }
        else
        {
        this.tipoTitular = false
        this.$validator.reset()
          this.dependents = Object.assign({}, this.defaultDependents)
          this.editedIndex = ''
          this.dataNascDependent = ''
        this.dialog = true
        }
      },
      openDialogDelete(item){
        this.editedIndex = item.id
        this.dependents = Object.assign({}, item)
        //this.dependentesCaarj = Object.assign({}, item)
        this.$validator.reset()
        this.dialogDelete = true
      },
      close() {
        this.dialogDelete = false
        this.senha = ''
        this.financialManagers.password = ''
        this.financialManagers.confirmPassword = ''
        this.primeiroAcesso = false
        this.atualizarSenha = false
        this.dialogCartao = false
          this.dialogLoading = false
          this.dialog = false
          this.dialogSenha = false
          this.$validator.reset()          
          setTimeout(() => {
            this.modelCartao = Object.assign({}, this.defaltModelCartao)
            this.$validator.reset()
            this.usarDadosFM = true
          }, 800);
          setTimeout(() => {
          this.dependents = Object.assign({}, this.defaultDependents)
          this.caarjDependente = Object.assign({}, this.caarjDependenteDefalt)
          this.editedIndex = ''
          this.editedIndexTitular = ''
          this.dataNascDependent = ''
          }, 300)
      },

    

        scrollToClass(className) {
            // Get the first element with the given class name
            let el = this.$el.querySelector(className)
            // Get the bounding rectangle so we can get the element position position
            let rect = el.getBoundingClientRect()
            // Scroll to the element (using x and y axis)
            window.scrollTo(rect.left, rect.top)
            },
            scrollbotton(){
            window.scrollTo(0, 3000)
        },

      async consultaTitular()
      {
          this.titularContrato = []
          this.possuiContrato = false
          var vm2
          if(/* this.senha == '' || */ this.cpf == '')
          {
              this.$validator.validateAll()
          }
          else
          {
          this.loading = true
          
           await axios.get(`${baseApiUrl}caarjs?filter[where][cpf]=${this.cpf}`).then(res => {        
            if(res.data != ''){      
                this.idAssociado = res.data[0].id
                this.dependentesCarregados =  res.data[0].dependentes                                                         
                
            }   
/*             else
            this.primeiroAcesso = true   */     	
          })

/*           if(this.primeiroAcesso == true)
          {  */
          await axios.post(`${baseApiUrl}APIS4s/Associados`, {"cpf": this.cpf,"empresa": 0,"incluirDependentes":1}).then(res => {                       
            if(res.data.Data[0] != '') {
            this.loading = false 
            res.data.Data.forEach( (titular) => {
                if(titular.CodigoEmpresa == '502192'){
                  if(titular.Dependente[0].Situacao == "2")
                    {
                      this.contratoCancelado = true                      
                    }
                    else
                    {
                    this.carrj.contratoEmpresa = '502192'
                    this.possuiContrato = true
                    this.titularContrato = titular
                    this.caarjS4E.codigoResponsavelFinanceiro = titular.Id
                    this.planoId = titular.Dependente[0].IdPlano
                    this.ativarAssociado.codigoAssociado = titular.Dependente[0].Id
                    }
                }
                else
                if(titular.CodigoEmpresa == '502229'){
                  if(titular.Dependente[0].Situacao == "2")
                    {
                      this.contratoCancelado = true
                    }
                  else
                    {
                    this.carrj.contratoEmpresa = '502229'
                    this.possuiContrato = true
                    this.titularContrato = titular
                    this.caarjS4E.codigoResponsavelFinanceiro = titular.Id
                    this.planoId = titular.Dependente[0].IdPlano
                    this.valorContrato = '22,00'
                    this.estagiario = true
                    this.valorTotalProposta = '22,00'
                    this.valorTitular = '22,00'
                    this.ativarAssociado.codigoAssociado = titular.Dependente[0].Id
                    }              
                }
                
            })
            if(this.contratoCancelado)
            {
                vm2 = this;
                vm2.$refs.chamaSnackbar.snack("#F9A825","Situação do contrato não permite continuar, contate a Primavida Dental!","ATENÇÃO")
                this.loading = false
                this.primeiroAcesso = false
                this.exibeformulario = false
            }
            else
            if(!this.possuiContrato)
            {
                vm2 = this;
                vm2.$refs.chamaSnackbar.snack("#F9A825","Contrato não pertencente à parceria!","ATENÇÃO")
                this.loading = false
                this.primeiroAcesso = false
                this.exibeformulario = false
            }else
            {

                          this.financialManagers.firstName = this.titularContrato.Nome
                          this.carrj.titular = this.titularContrato.Nome
                          this.financialManagers.cpf = this.titularContrato.CPF
                          this.carrj.cpf = this.titularContrato.CPF
                          if(this.titularContrato.Sexo == 'M'){
                          this.financialManagers.gender = 1
                          this.carrj.sexo = 'MASCULINO'
                          }    
                          else
                          {
                          this.financialManagers.gender = 0
                          this.carrj.sexo = 'FEMININO'
                          }
                          this.financialManagers.rg = this.titularContrato.Identidade
                          this.carrj.rg = this.titularContrato.Identidade
                          this.dataNasc = this.titularContrato.DataNascimento
                          this.carrj.nascimento = this.titularContrato.DataNascimento
                          this.carrj.contrato = this.titularContrato.Contrato
                          this.financialManagers.addressNumber = this.titularContrato.Numero                 
                          this.financialManagers.addressComplement = this.titularContrato.Complemento                           
                          this.exibeformulario = true
                          setTimeout(() => {
                            this.scrollToClass('.exibeplanos')
                            }, 500);

            }
            }
            else
            {
            vm2 = this;
            vm2.$refs.chamaSnackbar.snack("#F9A825","Titular não localizado, entre em contato com a CAARJ para a atualização de seus dados!","ATENÇÃO")
            this.loading = false
            this.primeiroAcesso = false
            this.atualizarSenha = false
            }        	
            })
          }                    

        },
        async insereDependenteS4E(dados)
        {
            await axios.post(`${baseApiUrl}APIS4s/NovoDependente`, dados).then(res => {   
              if(res.data != "") 
                this.salvaLogDependente(res.data.mensagem)

              if(res.data.codigo == 1) {
                   this.mensagemS4E.push(dados.dependente.nome + ' inserido(a) com sucesso!')
                   this.carrj.enviado = 'atualizado'                                        
                }                                     
                else
                 if(res.data.mensagem != null && res.data.mensagem.includes("Titular nao")) {
                   this.mensagemS4E.push('Não foi possível inserir ' + dados.dependente.nome + ', titular não pode inserir dependentes no contrato, contate a Primavida Dental!')
                   this.carrj.enviado = 'pendente'                   
                }
                else 
                if(res.data.mensagem != null && res.data.mensagem.includes("cadastrado e ativo no contrato")) {
                   this.mensagemS4E.push(dados.dependente.nome + ' já possui cadastro ativo no contrato ' + 'com o CPF : ' + dados.dependente.cpf )
                   this.carrj.enviado = 'atualizado' 
                }
                              
                }).catch(() => {
                    this.mensagemS4E.push('Erro ao inserir Dependentes / Agregados no contrato, contate à administração do sistema!')
                    this.carrj.enviado = 'pendente'                  
                  })
            

        },

        async ativarAssociadoS4E(){
           await axios.post(`${baseApiUrl}APIS4s/AtivarTitulares`, this.ativarAssociado)

        },

        async salvaLogDependente(mensagem){          
           await axios.post(`${baseApiUrl}logDependentes`, {"mensagem" : mensagem, "data" : new Date().toLocaleString(), "titular" : this.caarjS4E.codigoResponsavelFinanceiro})
        },

        async finalizarProposta(){
            this.loadingFinal = true
            this.carrj.dependentes = this.dependentes

            if(this.estagiario)
            await this.ativarAssociadoS4E()

            var enviaDependentes = []
          if(this.dependentesCaarj != '')
            {
                  for(var i=0; i<this.dependentesCaarj.length; i++) {
                  this.caarjS4E.dependente = this.dependentesCaarj[i]
                  enviaDependentes.push(this.caarjS4E)
                  this.caarjS4E = Object.assign({}, this.caarjS4EDefault)  
                  this.caarjS4E.codigoResponsavelFinanceiro =  this.titularContrato.Id 
                    
                  } 
                  
                  for(var i2=0; i2<enviaDependentes.length; i2++) {
                    await this.insereDependenteS4E(enviaDependentes[i2])
                  }           
            }
            setTimeout(() => {
              if(this.idAssociado == '')
            {
                axios.post(`${baseApiUrl}caarjs/replaceOrCreate`, this.carrj).then(res => {         
                if(res.data != ''){
                    this.loadingFinal = false 
                    this.dialogLoading = true                                
                  }              	
                  })
            }else
            {
                
                if(this.dependentesCarregados != '')
                this.carrj.dependentes = this.dependentes.concat(this.dependentesCarregados)
                else
                this.carrj.dependentes = this.dependentes
                axios.patch(`${baseApiUrl}caarjs/${this.idAssociado}`, this.carrj).then(res => {         
                if(res.data != ''){
                    this.loadingFinal = false 
                    this.dialogLoading = true                                
                  }              	
                  })
            }
            }, 6000);
            
            
        },
        confirmaContrato(){
        this.close()
        window.location.reload()
      },

      async titularSemEndereco(){
        var listaCarrj = []
        await axios.get(`${baseApiUrl}caarjs?`).then(res => {                   
                if(res.data != ''){
                  res.data.forEach( (item) => {
                  if (item.cidade == undefined)
                     listaCarrj.push(item) // entao remove                              
                  })
                                                   
                  }
        })
      }
        
}

}
</script>

<style>

    .link{
        font-size: 1.3rem;
        color: #194383;
        text-align: center;
    }
    .titulo{
        font-size: 2rem;
        color: #797a7a;
        text-align: center;
    }
    .imagemcaarj{
        background: url('https://www.apvs.com.br/assets/uploads/parceiros/caarj.png')no-repeat;
        background-size: 500px;
    }
</style>